import { Modal, useTranslation, Icon } from '@testsigma/atoms';
import { useContext } from 'react';
import { WindowsAdvancedElementsContext } from '../../list/windows-advanced-elements-context';

export const WindowsAdvancedElementImportSummaryPopup = () => {
  const { t } = useTranslation();
  const { currentElementFile, updateCurrentPopup } =
    useContext(WindowsAdvancedElementsContext);

  return (
    <Modal
      isOpen={true}
      closeOnEscape
      closeOnOutsideClick
      onClose={() => updateCurrentPopup(null)}
      className='min-w-[480px] max-w-[480px] relative !rounded-xl'>
      <Icon
        name='close'
        className='text-lg text-primary-900 cursor-pointer absolute top-5 right-5'
        onClick={() => updateCurrentPopup(null)}
      />
      <div className='text-lg font-medium text-unique-600 mb-6'>
        {t(
          currentElementFile
            ? 'uft.import.update.summary'
            : 'uft.import.summary',
        )}
      </div>

      <div className='mb-6 flex gap-6 flex-col'>
        <div className='flex w-full'>
          <div className='w-1/2 flex flex-col gap-1'>
            <div className='text-xs text-secondary-600'>
              {t('uft.current.file')}
            </div>
            <div className='text-xs font-medium text-primary-900'>
              {currentElementFile.file}
            </div>
          </div>

          <div className='w-1/2 flex flex-col gap-1'>
            <div className='text-xs text-secondary-600'>
              {t('common.lastupdate')}
            </div>
            <div className='text-xs font-medium text-primary-900'>
              {currentElementFile.updatedOn}
            </div>
          </div>
        </div>

        <div className='flex w-full'>
          <div className='w-1/2 flex flex-col gap-1'>
            <div className='text-xs text-secondary-600'>
              {t('uft.current.file.total')}
            </div>
            <div className='text-xs font-medium text-primary-900'>
              {currentElementFile.total}
            </div>
          </div>

          <div className='w-1/2 flex flex-col gap-1'>
            <div className='text-xs text-secondary-600'>
              {t('uft.current.file.new')}
            </div>
            <div className='text-xs font-medium text-primary-900'>
              {currentElementFile.added > 0 ? currentElementFile.added : '-'}
            </div>
          </div>
        </div>

        <div className='flex w-full'>
          <div className='w-1/2 flex flex-col gap-1'>
            <div className='text-xs text-secondary-600'>
              {t('uft.current.file.updated')}
            </div>
            <div className='text-xs font-medium text-primary-900'>
              {currentElementFile.updated > 0
                ? currentElementFile.updated
                : '-'}
            </div>
          </div>

          <div className='w-1/2 flex flex-col gap-1'>
            <div className='text-xs text-secondary-600'>
              {t('uft.current.file.deleted')}
            </div>
            <div className='text-xs font-medium text-primary-900'>
              {currentElementFile.deleted > 0
                ? currentElementFile.deleted
                : '-'}
            </div>
          </div>
        </div>
      </div>

      {/* <div className='mt-6'>
        <div className='text-xs font-medium text-primary-900'>
          {t('uft.summary.note.title')}
        </div>
        <div className='text-xs text-secondary-600 mt-2'>
          {t('uft.summary.note.desc')}
        </div>
      </div> */}
    </Modal>
  );
};
